import { ColumnMenuItem } from '../../../../../types';
import { useColumnSelector } from '../../../providers/ColumnSelectorProvider';
import { GroupColumnMenu as UnifiedGroupColumnMenu } from '../../../../../components/ColumnManagement';

import type { JSX } from 'react';

type Props = {
  groupName: string;
  columns: ColumnMenuItem[];
};

export const GroupColumnMenu = ({ groupName, columns }: Props): JSX.Element => {
  const { activeOrder, setActiveOrder } = useColumnSelector();

  // Create a provider-compatible object
  const provider = {
    selectedColumns: activeOrder,
    setSelectedColumns: setActiveOrder,
  };

  return <UnifiedGroupColumnMenu groupName={groupName} columns={columns} provider={provider} />;
};
